import { render, staticRenderFns } from "./BaseAutocomplete.vue?vue&type=template&id=1da3f981&scoped=true"
import script from "./BaseAutocomplete.vue?vue&type=script&lang=js"
export * from "./BaseAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./BaseAutocomplete.vue?vue&type=style&index=0&id=1da3f981&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da3f981",
  null
  
)

export default component.exports